module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.desserts
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_c('v-edit-dialog', {
          attrs: {
            "return-value": props.item.name,
            "lazy": ""
          },
          on: {
            "update:returnValue": function($event) {
              return _vm.$set(props.item, "name", $event)
            },
            "update:return-value": function($event) {
              return _vm.$set(props.item, "name", $event)
            }
          }
        }, [_vm._v(" " + _vm._s(props.item.name) + "\n        "), _c('v-text-field', {
          attrs: {
            "slot": "input",
            "rules": [_vm.max25chars],
            "label": "Edit",
            "single-line": "",
            "counter": ""
          },
          slot: "input",
          model: {
            value: (props.item.name),
            callback: function($$v) {
              _vm.$set(props.item, "name", $$v)
            },
            expression: "props.item.name"
          }
        })], 1)], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.calories))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.fat))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.carbs))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.protein))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_c('v-edit-dialog', {
          attrs: {
            "return-value": props.item.iron,
            "large": "",
            "lazy": "",
            "persistent": ""
          },
          on: {
            "update:returnValue": function($event) {
              return _vm.$set(props.item, "iron", $event)
            },
            "update:return-value": function($event) {
              return _vm.$set(props.item, "iron", $event)
            }
          }
        }, [_c('div', [_vm._v(_vm._s(props.item.iron))]), _vm._v(" "), _c('div', {
          staticClass: "mt-3 title",
          attrs: {
            "slot": "input"
          },
          slot: "input"
        }, [_vm._v("Update Iron")]), _vm._v(" "), _c('v-text-field', {
          attrs: {
            "slot": "input",
            "rules": [_vm.max25chars],
            "label": "Edit",
            "single-line": "",
            "counter": "",
            "autofocus": ""
          },
          slot: "input",
          model: {
            value: (props.item.iron),
            callback: function($$v) {
              _vm.$set(props.item, "iron", $$v)
            },
            expression: "props.item.iron"
          }
        })], 1)], 1)]
      }
    }, {
      key: "pageText",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n    From " + _vm._s(pageStart) + " to " + _vm._s(pageStop) + "\n  ")]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2022fec3","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings.vue
// module id = 816
// module chunks = 40